export const nativePlatformFiltersInitialState = {
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  // contentTypeFilter: {
  //   hasFilter: false,
  //   isOpen: false,
  //   selectedValue: 'both',
  //   componentName: 'contentTypeFilter',
  //   translateKey: 'filter:contentType',
  // },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'telegram',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
};
